module.exports = __webpack_public_path__ + "img/4_115.6056f834.png";